import React from 'react';
import Link, {skipToNative} from './link.js';
import Image from './image.js';
import InlineLoader from './inline-loader.js';
import {intlShape, defineMessages} from 'react-intl';
import {reisy, use} from 'reisy';
import PropTypes from 'prop-types';
import Heading from './heading';

const messages = defineMessages({
	stories: {
		id: 'cover.stories',
		defaultMessage: `{itemCount, plural,
			one {Story}
			other {Stories}
		}`,
	},
});

export const styles = reisy`
@namespace Cover;

Size: 25em;

cover {
	width: $Size;
	height: $Size;
	box-shadow: 0px 0.25em 0.25em rgba(0, 0, 0, 0.15) /* 4px */;
	position: relative;
	display: block;
}
image {
	display: block;
	width: 100%;
	height: 100%;
}
shadow {
	@extends Helpers.AbsFull;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.17) 100%);
}
titles {
	position: absolute;
	bottom: 0;
	width: 100%;
	box-sizing: border-box;
	padding: 1.25em 0.625em 0.625em /* 20px 10px 10px */;
	color: white;
	text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3);
	font-family: $Fonts.title;
	text-align: center;
}
titlesStory {
	padding: 1.25em 0.625em;
	text-align: left;
}
title {
	font-size: 2.2625em;
	line-height: 1em;
	margin: 0 0.2762em;
	padding: 0;
	text-transform: uppercase;
	box-shadow: 0px 3px 0px -2px white, 0px 2px 2px -2px rgba(0, 0, 0, 0.3);
	color: #FFF;
}
titleStory {
	font-size: 1.875em;
	margin: 0;
	box-shadow: none;
}
subtitle {
	font-family: $Fonts.subtitle;
	font-size: 1.3563em;
	font-weight: 400;
	line-height: 1em;
	margin: 0;
	padding-top: 0.4em;
	color: #FFF;
}
subtitleStory {
	padding: 0;
	line-height: inherit;
}
count {
	font-size: 0.875em;
	font-weight: 400;
	margin: 0;
	padding: 2em 0 0.1428em;
	text-align: right;
	line-height: 1em;
	letter-spacing: 0.05em;
	color: #FFF;
}
num {
	font-weight: bold;
	font-size: 3.4286em;
	letter-spacing: 0;
}
`;

class Cover extends React.Component {
	constructor(props) {
		super(props);
		this.state = {loading: false};
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick(ev) {
		const {onClick} = this.props;
		if (onClick) {
			onClick(ev);
		}
		if (ev.defaultPrevented || skipToNative(ev)) {
			return;
		}
		this.setState({loading: true});
	}
	render() {
		const {to, style, useShareImage} = this.props;
		let {content} = this.props;
		const {formatMessage} = this.context.intl;
		if ((content.type === 'user' || content.type === 'publisher') && content.index) {
			content = content.index;
		}
		const isStory = content.type === 'story';
		const image = (useShareImage && content.shareImage) || content.image;

		const children = [
			<Image
				key="image"
				style={styles.image}
				image={image}
				sizes={styles.Size}
				availWidth={500}
				ratio={1}
				cover lazy placeholder />,
			<div {...use(styles.shadow)} key="shadow" />,
			<div {...use(styles.titles, isStory && styles.titlesStory)} key="titles">
				<Heading lvl={2} {...use(styles.title, isStory && styles.titleStory)}>{content.title}</Heading>
				<Heading lvl={3} {...use(styles.subtitle, isStory && styles.subtitleStory)}>{content.subTitle}</Heading>
				{isStory ? null : <Heading lvl={3} {...use(styles.count)}>
					<span {...use(styles.num)}>{content.itemCount}</span>
					{` ${formatMessage(messages.stories, content)}`}
				</Heading>}
			</div>,
			this.state.loading ? <InlineLoader key="loading" /> : null,
		];

		const useStyle = use(styles.cover, style, content.options && content.options.className);

		if (to) {
			return (
				<Link {...useStyle} to={to} onClick={this.handleClick}>
					{children}
				</Link>
			);
		}

		return (
			<div {...useStyle}>{children}</div>
		);
	}
}

Cover.propTypes = Object.assign({}, Link.propTypes, {
	content: PropTypes.object.isRequired,
	useShareImage: PropTypes.bool,
	style: PropTypes.string,
});
Cover.contextTypes = {
	intl: intlShape,
};

export default Cover;



// WEBPACK FOOTER //
// ./lib/components/cover.js